import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { categories, mainSiteUrl } from '@/mocks/categories';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-foreground-950">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6 md:py-20">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
          <div className="md:col-span-4">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-white">
                <i className="ri-grid-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold text-white">
                {t('nav.brand')}
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-white/60">
              {t('footer.tagline')}
            </p>
            <Link
              to="/allchinabuy-spreadsheet-guide"
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-white px-6 py-3 text-sm font-semibold text-foreground-900 transition-colors hover:bg-background-100 cursor-pointer"
            >
              {t('footer.readGuide')}
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-sm font-semibold uppercase tracking-wider text-white/80">
              {t('footer.popularCategories')}
            </h4>
            <ul className="mt-6 grid grid-cols-2 gap-x-4 gap-y-3">
              {categories.slice(0, 10).map((cat) => (
                <li key={cat.id}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-white/50 transition-colors hover:text-primary-400 cursor-pointer"
                  >
                    {t(`categories.${cat.id}`, cat.name)}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-sm font-semibold uppercase tracking-wider text-white/80">
              {t('footer.quickLinks')}
            </h4>
            <ul className="mt-6 space-y-3">
              <li>
                <a
                  href={mainSiteUrl}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-white/50 transition-colors hover:text-primary-400 cursor-pointer"
                >
                  {t('footer.mainStore')}
                </a>
              </li>
              <li>
                <a
                  href={mainSiteUrl}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-white/50 transition-colors hover:text-primary-400 cursor-pointer"
                >
                  {t('footer.buyNow')}
                </a>
              </li>
              <li>
                <Link
                  to="/allchinabuy-spreadsheet-guide"
                  className="text-sm text-white/50 transition-colors hover:text-primary-400 cursor-pointer"
                >
                  {t('footer.completeGuide')}
                </Link>
              </li>
              <li>
                <Link
                  to="/"
                  className="text-sm text-white/50 transition-colors hover:text-primary-400 cursor-pointer"
                >
                  {t('footer.allCategories')}
                </Link>
              </li>
              <li>
                <a
                  href="/#faq"
                  className="text-sm text-white/50 transition-colors hover:text-primary-400 cursor-pointer"
                >
                  {t('footer.faq')}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-8 sm:flex-row">
          <p className="text-xs text-white/40">
            © {new Date().getFullYear()} AllChinaBuySpread. {t('footer.copyright')}
          </p>
          <div className="flex items-center gap-4">
            <Link
              to="/"
              className="text-xs text-white/40 transition-colors hover:text-white/60 cursor-pointer"
            >
              {t('footer.home')}
            </Link>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="text-xs text-white/40 transition-colors hover:text-white/60 cursor-pointer"
            >
              {t('footer.mainStoreShort')}
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="rounded-full bg-primary-500 px-4 py-2 text-xs font-semibold text-white transition-colors hover:bg-primary-600 cursor-pointer"
            >
              {t('nav.sheetCta')}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}